var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wrap',_vm._g(_vm._b({},'wrap',_vm.$props,false),_vm.$listeners),[_c('div',{staticClass:"rt-content px-3 py-2"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.options.body)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }